exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-9bbb1f06]{margin-top:1rem}p[data-v-9bbb1f06]{font-size:small;letter-spacing:normal;line-height:1.2rem!important;text-align:justify}", ""]);

// exports
